import type {
    DoNotMailChoice,
    DoNotMailStatus
} from '~/resources/graphql/graphql'

export function doNotMailValueFromStatus(
    doNotMailStatus: DoNotMailStatus | null
): boolean | null {
    // Missing and unanswered statuses both defer to the configured checkbox default.
    if (doNotMailStatus === null || doNotMailStatus === 'UNANSWERED') {
        return null
    }

    return doNotMailStatus === 'UNSUBSCRIBED'
}

export function doNotMailStatusFromValue(
    doNotMail: boolean | null
): DoNotMailStatus | undefined {
    // A hidden or unanswered checkbox must leave the saved preference untouched.
    if (doNotMail === null) {
        return undefined
    }

    return doNotMail ? 'UNSUBSCRIBED' : 'SUBSCRIBED'
}

export function doNotMailDefault(
    doNotMailDirection: DoNotMailChoice,
    doNotMailDefaultChecked: boolean
): boolean {
    // The configured default is a checkbox state, so convert it to the persisted preference.
    return doNotMailValue(doNotMailDirection, doNotMailDefaultChecked)
}

export function doNotMailInitialValue(
    doNotMailStatus: DoNotMailStatus | null,
    doNotMailDirection: DoNotMailChoice,
    doNotMailDefaultChecked: boolean,
    triStateDoNotMailEnabled: boolean
): boolean {
    const configuredDefault = doNotMailDefault(
        doNotMailDirection,
        doNotMailDefaultChecked
    )

    if (!triStateDoNotMailEnabled) {
        // Legacy checkout is authoritative on every submission, so saved preferences never replace its default.
        return configuredDefault
    }

    // Tri-state checkout preserves explicit answers while unanswered customers still see the configured default.
    return doNotMailValueFromStatus(doNotMailStatus) ?? configuredDefault
}

export function doNotMailChecked(
    doNotMailDirection: DoNotMailChoice,
    doNotMail: boolean
): boolean {
    // Opt-in is the inverse of do_not_mail; opt-out has the same meaning as do_not_mail.
    if (doNotMailDirection === 'OPT_IN') {
        return !doNotMail
    }

    return doNotMail
}

export function doNotMailValue(
    doNotMailDirection: DoNotMailChoice,
    newValue: boolean
): boolean {
    // Both visible answers are explicit customer preferences and must persist as booleans.
    if (doNotMailDirection === 'OPT_IN') {
        return !newValue
    }

    return newValue
}
